import { useEffect, useState } from "react";
import BestSellersSection from "../BestSellersSection/BestSellersSection";
import CallToActionSection from "../CallToActionSection/CallToActionSection";
import Cart from "../Cart/Cart";
import CategoryFilter from "../CategoryFilter/CategoryFilter";
import FeaturedSection from "../FeaturedSection/FeaturedSection";
import FeaturesShowcase from "../FeatureShowcases/FeatureShowcases";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Hero from "../Hero/Hero";
import NewReleasesSection from "../NewReleasesSection/NewReleasesSection";
import ProductList from "../ProductList/ProductList";
import ProductModal from "../ProductModal/ProductModal";
import { getService } from "../GenericServices/genericService";

const Home = ({
  cart,
  setCart,
  searchTerm,
  setSearchTerm,
  location,
  navigate,
  isLoggedIn,
  logout,
  featuredProducts,
  addToCart,
  total,
  removeFromCart,
}) => {
  const [cartOpen, setCartOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [homeData, setHomeData] = useState({
    newRelease: [],
    playStation5: [],
    playStation4: [],
    ninetendoSwitch: [],
    xboxSeriesX: [],
    xboxSeriesS: [],
  });

  useEffect(() => {
    homeAPI();
  }, []);

  /* Get Home Data */
  const homeAPI = () => {
    // Implement API call to fetch products and setProducts
    const url = "myNewAPI/home.php";
    getService(url, {}, getHomeData);
  };

  const getHomeData = (response) => {
    console.log("homeData", response);
    let responseData = {};
    response?.categories.map((item) => {
      if (item.id === "1") {
        responseData.xboxSeriesX = item.products;
      }
      if (item.id === "2") {
        responseData.playStation5 = item.products;
      }
      if (item.id === "3") {
        responseData.xboxSeriesS = item.products;
      }
      if (item.id === "4") {
        responseData.playStation4 = item.products;
      }
      if (item.id === "5") {
        responseData.nintendoSwitch = item.products;
      }
    });

    console.log("responseData", responseData);
    setHomeData({
      playStation5: responseData.playStation5,
      playStation4: responseData.playStation4,
      nintendoSwitch: responseData.nintendoSwitch,
      xboxSeriesX: responseData.xboxSeriesX,
      xboxSeriesS: responseData.xboxSeriesS,
      newRelease: response.new_releases,
    });
  };
  console.log("homeData", homeData);
  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        cartCount={cart.length}
        onCartClick={() => setCartOpen(!cartOpen)}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        pathname={location.pathname}
        navigate={navigate}
        isLoggedIn={isLoggedIn}
        logout={logout}
      />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Hero />
        <FeaturesShowcase />
        <FeaturedSection
          products={homeData.newRelease}
          onAddToCart={addToCart}
          onProductClick={setSelectedProduct}
          heading={"New Releases"}
          subHeading={
            "Experience the next generation of gaming with our new releases, featuring exclusive games and enhanced performance for the ultimate gaming experience."
          }
        />
        <FeaturedSection
          products={homeData.playStation5}
          onAddToCart={addToCart}
          onProductClick={setSelectedProduct}
          heading={"Playstation 5"}
          subHeading={
            "Experience the next generation of gaming with our new PS5 edition, featuring exclusive games and enhanced performance for the ultimate gaming experience."
          }
        />
        <FeaturedSection
          products={homeData.playStation4}
          onAddToCart={addToCart}
          onProductClick={setSelectedProduct}
          heading={"Playstation 4"}
          subHeading={
            "Experience the next generation of gaming with our new PS4 edition, featuring exclusive games and enhanced performance for the ultimate gaming experience."
          }
        />
        <FeaturedSection
          products={homeData.nintendoSwitch}
          onAddToCart={addToCart}
          onProductClick={setSelectedProduct}
          heading={"Ninetendo Switch"}
          subHeading={
            "Experience the next generation of gaming with our new Nintendo Switch edition, featuring exclusive games and enhanced performance for the ultimate gaming experience."
          }
        />
        <FeaturedSection
          products={homeData.xboxSeriesX}
          onAddToCart={addToCart}
          onProductClick={setSelectedProduct}
          heading={"Xbox Series X"}
          subHeading={
            "Experience the next generation of gaming with our new Xbox Series X edition, featuring exclusive games and enhanced performance for the ultimate gaming experience."
          }
        />
        <FeaturedSection
          products={homeData.xboxSeriesS}
          onAddToCart={addToCart}
          onProductClick={setSelectedProduct}
          heading={"Xbox Series S"}
          subHeading={
            "Experience the next generation of gaming with our new Xbox Series S edition, featuring exclusive games and enhanced performance for the ultimate gaming experience."
          }
        />
        <CallToActionSection />
      </main>
      <Footer />
      {cartOpen && (
        <Cart
          cart={cart}
          total={total}
          onRemove={removeFromCart}
          onClose={() => setCartOpen(false)}
          onCheckout={() => {
            if (cart.length > 0) {
              navigate("/checkout");
              setCartOpen(false);
            } else {
              alert("Your cart is empty!");
            }
          }}
        />
      )}
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onAddToCart={addToCart}
        />
      )}
    </div>
  );
};

export default Home;
